module.exports = __webpack_public_path__ + "media/images/gps-300e4bcfadb96a5dd6aa22642a9cb4fa.svg";